class SideDrawerToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", event => {
      event.preventDefault();

      if (this.getAttribute("data-drawer") === "all") return this.closeActiveDrawers();
      if (this.classList.contains("drawers-close-active")) this.closeActiveDrawers();

      // Get drawer element by ID from click event target data attribute
      const drawer = document.getElementById(this.getAttribute("data-drawer"));

      if (drawer) {
        const drawerContent = drawer.querySelector(".drawer__content");

        drawer.dispatchEvent(new Event("drawer-toggle"));
        drawerContent.scrollTop = 0;

        this.classList.toggle('active');
      }
    });
  }

  closeActiveDrawers() {
    const activeDrawers = document.querySelectorAll("side-drawer.active");

    if (!activeDrawers) return;

    activeDrawers.forEach(el => el.dispatchEvent(new Event("drawer-toggle")));
  }
}

customElements.define("side-drawer-toggle", SideDrawerToggle);
